import isPlainObj from"is-plain-obj";

















export const mergePluginsOpts=(oldOpts,newOpts,plugins)=>
Object.fromEntries(
getPluginNames(plugins).
map((name)=>mergePluginOpts(oldOpts,newOpts,name)).
filter(Boolean)
);

const mergePluginOpts=(oldOpts,newOpts,name)=>{
const pluginOpt=mergeOpt(oldOpts[name],newOpts[name]);
return pluginOpt===undefined?undefined:[name,pluginOpt]
};

const mergeOpt=(oldOpt,newOpt)=>{
if(newOpt===undefined){
return oldOpt
}

if(isPlainObj(oldOpt)&&isPlainObj(newOpt)){
return{...oldOpt,...newOpt}
}

return newOpt
};

export const getPluginNames=(plugins)=>plugins.map(getPluginName);

const getPluginName=({name})=>name;